"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { keyframes } from "@emotion/react";
import { useCustomTheme } from "../../../core/design-system/CustomThemeProvider.js";
import { radius } from "../../../core/design-system/index.js";
import { StyledDiv } from "../design-system/elements.js";
/**
 * @internal
 */
export const Skeleton = (props) => {
    return (_jsx(SkeletonDiv, { color: props.color, style: {
            height: props.height,
            width: props.width || "auto",
        }, className: props.className || "" }));
};
const skeletonAnimation = keyframes `
0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;
const SkeletonDiv = /* @__PURE__ */ StyledDiv((props) => {
    const theme = useCustomTheme();
    return {
        backgroundSize: "200% 200%",
        backgroundColor: theme.colors[props.color || "skeletonBg"],
        animation: `${skeletonAnimation} 500ms ease-in-out infinite alternate`,
        borderRadius: radius.sm,
    };
});
//# sourceMappingURL=Skeleton.js.map